module.exports = __webpack_public_path__ + "img/1908.002c7a34.png";